const dateTimeFmt = new Intl.DateTimeFormat('de-DE', {
  weekday: 'short',
  day: '2-digit',
  month: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
});

const dateFmt = new Intl.DateTimeFormat('de-DE', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
});

const timeFmt = new Intl.DateTimeFormat('de-DE', {
  hour: '2-digit',
  minute: '2-digit',
});

export function formatDateTime(iso: string | Date): string {
  const d = typeof iso === 'string' ? new Date(iso) : iso;
  return dateTimeFmt.format(d);
}

export function formatDate(iso: string | Date): string {
  const d = typeof iso === 'string' ? new Date(iso) : iso;
  return dateFmt.format(d);
}

export function formatTime(iso: string | Date): string {
  const d = typeof iso === 'string' ? new Date(iso) : iso;
  return timeFmt.format(d);
}

export function formatDateRange(startIso: string, endIso: string): string {
  const s = new Date(startIso);
  const e = new Date(endIso);
  const sameDay =
    s.getFullYear() === e.getFullYear() &&
    s.getMonth() === e.getMonth() &&
    s.getDate() === e.getDate();
  if (sameDay) {
    return `${dateTimeFmt.format(s)} – ${timeFmt.format(e)}`;
  }
  return `${dateTimeFmt.format(s)} – ${dateTimeFmt.format(e)}`;
}

/** ISO-Datum mit lokaler Zeit für <input type="datetime-local"> */
export function toDateTimeLocal(iso: string | Date): string {
  const d = typeof iso === 'string' ? new Date(iso) : iso;
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

/** Lokales <input>-Datum zurück nach ISO-UTC */
export function fromDateTimeLocal(local: string): string {
  // `local` ist z. B. "2026-05-26T10:00" — interpretiert als lokale Zeit.
  const d = new Date(local);
  return d.toISOString();
}

/** Anzeige der Flugroute: A → B oder A → B → A bei Hin-/Rueckflug. */
export function formatRoute(
  fromLocation: string,
  toLocation: string,
  roundTrip: boolean,
): string {
  return roundTrip
    ? `${fromLocation} → ${toLocation} → ${fromLocation}`
    : `${fromLocation} → ${toLocation}`;
}
